
import {defineComponent} from "vue";
import {useToast} from "vue-toastification";
import {
  UserRegistrationOverviewResultsRestDtoModel
} from "@/models/api/pharma-auth-urr/UserRegistrationOverviewResultsRestDtoModel";
import {ValueEnum} from "@/api/enums/value-enum";
import {UIStateDto} from "@/dtos/UIStateDto";
import {ErrorHandlerQueue} from "@/error/ErrorHandlerQueue";
import {DpExceptionsErrorHandler} from "@/error/handlers/DpExceptionsErrorHandler";
import {AxiosErrorHandler} from "@/error/handlers/AxiosErrorHandler";
import {UserRegistrationRuleRestService} from "@/services/rest/auth-urr/UserRegistrationRuleRestService";
import {UrrSimulationInputRestDtoModel} from "@/models/api/pharma-auth-urr/UrrSimulationInputRestDtoModel";
import AlertError2 from "@/components/UI/Bootstrap/Alert/AlertError2.vue";
import BaseTitle from "@/components/UI/BaseTitle.vue";
import BaseContainer from "@/components/UI/Bootstrap/BaseContainer.vue";
import {StatusEnum} from "@/api/enums/status-enum";
import BaseModal from "@/components/UI/Bootstrap/Modal/BaseModal.vue";
import InputText from "@/components/UI/InputText.vue";
import {generateDomId} from "@/helpers/functions/string";
import {default as Modal} from "bootstrap/js/dist/modal";
import {UrrSimulationOutputRestDto, UserRegistrationRuleOverviewRestDto} from "@/api/pharma-auth-urr/models";
import Subtitle from "@/components/UI/Subtitle.vue";

export default defineComponent({
  name: "UserRegistrationRuleOverview",
  components: {Subtitle, InputText, BaseModal, AlertError2, BaseTitle, BaseContainer},
  data: () => ({
    pageUI: UIStateDto.createWithDefaults(),
    toaster: useToast(),

    simulateInput: UrrSimulationInputRestDtoModel.createWithDefaults(),
    overviewResult: UserRegistrationOverviewResultsRestDtoModel.createWithDefaults(),

    simulateModalId: generateDomId(),
    simulateModal: null as Modal | null,

    simulationRule: null as UserRegistrationRuleOverviewRestDto | null,
    simulationOutput: null as UrrSimulationOutputRestDto | null,
  }),
  mounted() {
    this.simulateModal = new Modal('#' + this.simulateModalId);
    this.reloadContent();
  },
  computed: {
    StatusEnum() {
      return StatusEnum
    },
  },
  methods: {
    async reloadContent() {
      this.pageUI
          .setNotReady()
          .clearError();

      try {
        this.overviewResult = await UserRegistrationRuleRestService.getInstance().findUserRegistrationRules();
      } catch (exceptions: unknown) {
        this.setExceptions(exceptions);
      } finally {
        this.pageUI.setReady();
      }
    },
    async updateStatus(id: string, status: ValueEnum): Promise<void> {
      this.pageUI
          .setNotReady()
          .clearError();

      try {
        await UserRegistrationRuleRestService.getInstance().updateUrrStatus(status, id);
        await this.reloadContent();
      } catch (exceptions: unknown) {
        this.setExceptions(exceptions);
      } finally {
        this.pageUI.setReady();
      }
    },
    openSimulationModal(rule: UserRegistrationRuleOverviewRestDto): void {
      this.simulationRule = rule;
      this.simulationOutput = null;

      // Show the modal
      this.simulateModal?.show();
    },
    async simulate(): Promise<void> {
      this.pageUI
          .setNotReady()
          .clearError();

      try {
        this.simulationOutput = await UserRegistrationRuleRestService.getInstance().simulate(this.simulateInput, this.simulationRule?.rule_id);
      } catch (exceptions: unknown) {
        this.setExceptions(exceptions);
      } finally {
        this.pageUI.setReady();
      }
    },
    setExceptions(exceptions: unknown): void {
      ErrorHandlerQueue
          .create()
          .add(DpExceptionsErrorHandler.createWithDefaultUIStateBehavior(this.pageUI as UIStateDto))
          .add(AxiosErrorHandler.createWithDefaultUIStateBehavior(this.pageUI as UIStateDto))
          .catch(exceptions, true);
    },
  }
});
